<template lang="pug">
#basicSetting
  el-form(ref="basicForm" :model="basicForm" size="small" :rules="rules" label-width="200px" label-position="right")
    el-form-item(label="分组名称" )
      el-input(v-model="basicForm.groupName" disabled)
    el-form-item(label="流程名称" prop="flowName")
      el-input(v-model="basicForm.flowName" size="small" maxlength="100"
      show-word-limit clearable @input="updateBasic" :disabled="viewMode === EditMode.VIEW_2")
    el-form-item(label="流程编码" prop="flowKey")
      el-input(v-model="basicForm.flowKey" :disabled="!canEditFlowCode()" maxlength="40" show-word-limit clearable
        oninput="value=value.replace(/[^\0-9a-zA-Z_\.\/\-]/ig,'')" @input="updateBasic")
      .tips 提示：只能输入数字、字母、下划线、减号，不能与已有流程编码重复
    el-form-item(label="表单" )
      el-radio(v-model="basicForm.customerForm" :label="2" :disabled="isViewMode" @change="updateBasic") 在线表单
      el-radio(v-model="basicForm.customerForm" :label="1" :disabled="isViewMode" @change="updateBasic") 自定义（默认）
      .tips 提示：在线表单: 表示通过表单设计器在线配置的表单; 自定义表单：表示代码开发的表单
    //- 此为低代码使用的发起表单
    el-form-item(label="发起表单" v-if="basicForm.customerForm===2 && source === 'lowcode'")
      el-form-item.inlineStyle(label="PC:" prop="formCode")
        .inlineList
          el-select.dynForm( v-model="basicForm.formCode" size="small"
            :disabled="viewMode === EditMode.VIEW_2" @change="formCodeChange('formCode','web')")
            el-option(v-for="item in formOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId")
          el-button(:disabled="!basicForm.formCode" type="text" size="small" @click="viewForm('formCode','web')") 预览
          div(v-if="basicForm.formNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formNamePathId,'web')") {{ basicForm.formNamePath }}
      el-form-item.inlineStyle(label="H5:")
        .inlineList
          el-select.dynForm( v-model="basicForm.formH5Code" size="small" clearable
            :disabled="viewMode === EditMode.VIEW_2" @change="formCodeChange('formH5Code','H5')")
            el-option(v-for="item in formOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId")
          el-button( :disabled="!basicForm.formH5Code" type="text" size="small" @click="viewForm('formH5Code','H5')") 预览
          div(v-if="basicForm.forH5mNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formH5NamePathId,'web')") {{ basicForm.formH5NamePath }}
    //- 此为低代码使用的审批表单
    el-form-item(label="审批表单" v-if="basicForm.customerForm===2 && source === 'lowcode'")
      el-form-item.inlineStyle(label="PC:")
        .inlineList
          el-select.dynForm( v-model="basicForm.formApprovePcCode" size="small" clearable
            :disabled="viewMode === EditMode.VIEW_2" @change="approveCodeChange('formApprovePcCode','web')")
            el-option(v-for="item in formOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId")
          el-button(:disabled="!basicForm.formApprovePcCode" type="text" size="small" @click="viewForm('formApprovePcCode','web')") 预览
          div(v-if="basicForm.formApprovePcNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formApprovePcNamePath,'web')") {{ basicForm.formApprovePcNamePath }}
      el-form-item.inlineStyle(label="H5:" )
        .inlineList
          el-select.dynForm( v-model="basicForm.formApproveH5Code" clearable size="small"
            :disabled="viewMode === EditMode.VIEW_2" @change="approveCodeChange('formApproveH5Code','H5')")
            el-option(v-for="item in formOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId")
          el-button(:disabled="!basicForm.formApproveH5Code" type="text" size="small" @click="viewForm('formApproveH5Code','H5')") 预览
          div(v-if="basicForm.formApproveH5NamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formApprovePcNamePath,'web')") {{ basicForm.formApprovePcNamePath }}
    //- 此为流程设置使用的发起表单
    el-form-item(label="发起表单" v-if="basicForm.customerForm === 2 && source === 'set'")
      el-form-item.inlineStyle(label="PC:" prop="formCode")
        .inlineList
          el-cascader.dynForm(v-model="basicForm.formCode" :disabled="viewMode === EditMode.VIEW_2" :props="defaultProps"
            :options="formList" @change="formCodeChange('formCode','web')" :show-all-levels="false")
          el-button(v-if="basicForm.formCode" type="text" size="small" @click="viewForm('formCode','web')") 预览
          div(v-if="basicForm.formNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formNamePathId,'web')") {{ basicForm.formNamePath }}
      el-form-item.inlineStyle(label="H5:")
        .inlineList
          el-cascader( v-model="basicForm.formH5Code" :disabled="viewMode === EditMode.VIEW_2" :show-all-levels="false"
            :props="defaultProps" :options="formList" clearable @change="formCodeChange('formH5Code','H5')")
          el-button( :disabled="!basicForm.formH5Code" type="text" size="small" @click="viewForm('formH5Code','H5')") 预览
          div(v-if="basicForm.forH5mNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formH5NamePathId,'web')") {{ basicForm.formH5NamePath }}
    //- 此为流程设置使用的审批表单
    el-form-item(label="审批表单" v-if="basicForm.customerForm===2 && source === 'set'")
      el-form-item.inlineStyle(label="PC:")
        .inlineList
          el-cascader(v-model="basicForm.formApprovePcCode" :disabled="viewMode === EditMode.VIEW_2" :show-all-levels="false"
            :props="defaultProps" :options="formList" clearable @change="approveCodeChange('formApprovePcCode','web')")
          el-button(:disabled="!basicForm.formApprovePcCode" type="text" size="small" @click="viewForm('formApprovePcCode','web')") 预览
          div(v-if="basicForm.formApprovePcNamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formApprovePcNamePath,'web')") {{ basicForm.formApprovePcNamePath }}
      el-form-item.inlineStyle(label="H5:" props)
        .inlineList
          el-cascader(v-model="basicForm.formApproveH5Code" :disabled="viewMode === EditMode.VIEW_2" :show-all-levels="false"
          :props="defaultProps" :options="formList" clearable @change="approveCodeChange('formApproveH5Code','H5')")
          el-button(:disabled="!basicForm.formApproveH5Code" type="text" size="small" @click="viewForm('formApproveH5Code','H5')") 预览
          div(v-if="basicForm.formApproveH5NamePath")
            el-button(type="text" size="small" title="点击跳转到表单编辑页面" @click="editForm(basicForm.formApprovePcNamePath,'web')") {{ basicForm.formApprovePcNamePath }}
    //- 选择表单后必填
    el-form-item(label="流程标题" prop="titleTemplate" v-if="basicForm.customerForm===2 && basicForm.formCode")
      el-input(v-model="basicForm.titleTemplate" :disabled="viewMode === EditMode.VIEW_2" @change="updateBasic")
      el-button(type="text" :disabled="viewMode === EditMode.VIEW_2" @click="handleBuildTitle") 构造标题
    el-form-item(label="流程摘要" v-if="basicForm.customerForm===2 && basicForm.formCode")
      el-input(type="textarea" :disabled="viewMode === EditMode.VIEW_2" :rows="3" placeholder="请输入流程摘要内容"
        v-model="basicForm.contentTemplate" @change="updateBasic")
      el-button(type="text" :disabled="viewMode === EditMode.VIEW_2" @click="handleBuildContent") 构造摘要
    el-form-item(label="项目内流程" prop="formType")
      el-radio(v-model="basicForm.formType" :label="1" :disabled="isViewMode" @change="updateBasic") 是，关联项目
      el-radio(v-model="basicForm.formType" :label="0" :disabled="isViewMode" @change="updateBasic") 否，不关联项目
    el-form-item(label="项目选择器" prop="formType" v-if="basicForm.formType")
      el-checkbox(v-model="basicForm.enablePrjSelector" :true-label="1" :false-label="0" :disabled="isViewMode" @change="updateBasic") 发起流程时，在页面上提供项目选择器
      .tips 提示：如果不提供项目选择器，则由表单内部自主处理
    el-form-item(label="项目分类流程" v-if="basicForm.formType" prop="isLimitByPrjCategory")
      .radioList
        el-radio(v-model="basicForm.isLimitByPrjCategory" :label="0" :disabled="isViewMode" @change="updateBasic") 通用流程, 不限定（默认）
        el-radio(v-model="basicForm.isLimitByPrjCategory" :label="1" :disabled="isViewMode" @change="updateBasic") 限定项目分类
    el-form-item(label="关联项目分类（多选）" prop="prjCategoryList" v-if="basicForm.isLimitByPrjCategory === 1")
      el-select(v-model="prjCategoryList" :disabled="isViewMode" multiple size="small" style="min-width: 300px")
        el-option(v-for="(item,index) in dataPrjType" :key="item.dicId" :value="item.dicId" :label="item.cnName")
    el-form-item(label="上传附件" )
      el-button(icon="el-icon-upload2" size="small" :disabled="isViewMode" @click="additionalUpload") 上传
      viewFileList(ref="viewFileList" :files="floderData" :noDelete="viewMode === EditMode.VIEW_2" @deleteFiles="deleteFiles")
    el-form-item(label="是否内部流程" prop="isInternal")
      .radioList
        el-radio(v-model="basicForm.isInternal" :label="1" :disabled="isViewMode" @change="updateBasic") 是
        el-radio(v-model="basicForm.isInternal" :label="0" :disabled="isViewMode" @change="updateBasic") 否（默认）
      .tips 提示：如果是内部流程，将不会显示在新建审批的界面上
    el-form-item(label="发起/查看流程界面的加载方式" prop="startMode")
      el-radio(v-model="basicForm.startMode" label="std" :disabled="isViewMode" @change="updateBasic") 使用公共的流程页面（默认）
      .tips 提示：这种方式下，将跳转到公共的流程发起页面，由它来加载业务组件
      el-radio(v-model="basicForm.startMode" label="stdNew" :disabled="isViewMode" @change="updateBasic") 新窗口打开公共的流程页面
      .tips 提示：这种方式下，将在新窗口打开公共的流程发起页面，由它来加载业务组件
      el-radio(v-model="basicForm.startMode" label="customize" :disabled="isViewMode" @change="updateBasic") 由业务自行决定
      .tips 提示：这种方式下，流程组件需要实现 open 等方法，以供框架层调用
    //-使用不多隐藏
    //- el-form-item(label="是否调用标准的流程接口" prop="methodInvokeMode")
      el-radio(v-model="basicForm.methodInvokeMode" label="std" :disabled="isViewMode" @change="updateBasic") 调用流程标准接口（默认）
      .tips 提示：这种方式下，发送、查询、重新发起等将会调用标准接口
      el-radio(v-model="basicForm.methodInvokeMode" label="customize" :disabled="isViewMode" @change="updateBasic") 由业务自行决定应该使用哪些接口
      .tips 提示：这种方式下，流程组件需要实现 start, restart, queryDetail 等方法，以供框架层调用
    el-form-item(label="无审批人是否可发起流程" prop="isStartByNoAssignee")
      el-radio(v-model="basicForm.isStartByNoAssignee" :label="1" :disabled="isViewMode" @change="updateBasic") 是（默认）
      el-radio(v-model="basicForm.isStartByNoAssignee" :label="0" :disabled="isViewMode" @change="updateBasic") 否
    el-form-item(label="是否允许从CAD插件发起流程" prop="cadCanStart")
      el-radio(v-model="basicForm.cadCanStart" :label="0" :disabled="isViewMode" @change="updateBasic") 否（默认）
      el-radio(v-model="basicForm.cadCanStart" :label="1" :disabled="isViewMode" @change="updateBasic") 是
    el-form-item(label="流程图标" prop="icon")
      el-radio-group(v-model="basicForm.icon" :disabled="isViewMode" @change="updateBasic")
        el-radio(v-for="num in 6" :key="num" :label="num - 1")
          img(:src="getImgUrl(num - 1)" alt="流程图标")
    el-form-item(label="流程通过后，抄送给" prop="ccList")
      div(v-if="ccUserList.length===0") (无抄送人)
      userItem(:userList="ccUserList" :disabled="isViewMode" v-if="ccUserList.length>0" @deleteUser="deleteCCUser")
      el-button.addPeople(icon="el-icon-plus" type="text" size="small" :disabled="isViewMode"  circle title="选择人员" @click="openCCPerson") 选择人员、角色或标签
    el-form-item(label="流程描述" prop="description")
      el-input(v-model="basicForm.description" :rows="3" type="textarea" maxlength="300" show-word-limit clearable :disabled="isViewMode")
  formViewDialog(:layoutType="layoutType" ref="formViewDialog" )
  contentBuilderByFormFieldsDlg(ref="contentBuilderByFormFieldsDlg" @ok="finishEdit")
</template>

<script>
import EditMode from "@/CommonDP/enums/EditMode";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import { flowParams, updateParams, changeFloderData, deleteFloderData, dealFrom, setFormFieldList, setFormFieldNull, getFormFieldList } from "../config";
import viewFileList from "../config/viewFileList.vue";
import formViewDialog from "../config/formViewDialog.vue";
import dicService from "@/CommonDP/service/dic-service.js";
import metadataService from "@/CommonDP/service/metadata-service.js";
import { mapState } from "vuex";
import contentBuilderByFormFieldsDlg from "./contentBuilderByFormFieldsDlg.vue";
import { uploader } from '@/CommonDP/utils/IUploader/dp';

export default {
  components: { userItem, formViewDialog, viewFileList, contentBuilderByFormFieldsDlg },
  props: {
    viewMode: {
      type: Number,
      default: EditMode.CREATE_0
    },
    // 是流程设置模板还是低代码设置模板
    source: {
      type: String,
      default: "set"
    }
  },
  data () {
    return {
      EditMode: EditMode,
      basicForm: flowParams.basicForm,
      rules: {
        flowName: [{ required: true, message: "请输入流程名称", trigger: "change" }],
        rejectRuleCode: [{ required: true, message: "请选择驳回规则", trigger: "change" }],
        flowKey: [{ required: true, message: "请输入表单模板编码", trigger: "change" }],
        titleTemplate: [{ required: true, message: "请输入流程标题", trigger: "change" }],
        formCode: [{ required: true, message: "请选择PC表单", trigger: "change" }],
        formH5Code: [{ required: true, message: "请选择H5表单", trigger: "change" }]
      },
      isFlowCodeNull: false, // 目前不知道干啥的
      formList: [],
      prjCategoryList: [],
      dataPrjType: [],
      defaultProps: {
        children: 'children',
        label: 'groupName',
        value: 'groupId',
        emitPath: false
      },
      layoutType: "", // 预览模式
      formIdType: "" // 表单id

    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    isViewMode() {
      return this.viewMode === EditMode.VIEW_2;
    },
    userSelectionParams() {
      return { canSelectSystemRole: false, canSelectProjectRole: false };
    },
    ccUserList() {
      return this.basicForm.ccList || [];
    },
    groupName() {
      return flowParams.groupName;
    },
    floderData() {
      return flowParams.attachedFiles || [];
    },
    formOptions() {
      return flowParams.selectFormList;
    },
    fieldList() { // 字段列表
      return getFormFieldList();
    }
  },

  mounted () {
    this.doInit();
  },
  methods: {
    async doInit() {
      await this.getPrjType();
      if (this.source === "set" && !this.isViewMode) {
        await this.getFromList();
      }
      this.prjCategoryList = this.basicForm.prjCategoryList || [];
      if (this.basicForm.formCode) {
        const pathInfo = await this.queryFormNamePath(this.basicForm.formCode);
        this.$set(this.basicForm, 'formNamePath', pathInfo.name);
        this.$set(this.basicForm, 'formNamePathId', pathInfo.id);
      }
      if (this.basicForm.formH5Code) {
        const pathInfo = await this.queryFormNamePath(this.basicForm.formH5Code);
        this.$set(this.basicForm, 'formH5NamePath', pathInfo.name);
        this.$set(this.basicForm, 'formH5NamePathId', pathInfo.id);
      }
      if (this.basicForm.formIdApprovePcCode) {
        const pathInfo = await this.queryFormNamePath(this.basicForm.formApprovePcCode);
        this.$set(this.basicForm, 'formApprovePcNamePath', pathInfo.name);
        this.$set(this.basicForm, 'formApprovePcNamePathId', pathInfo.id);
      }
      if (this.basicForm.formApproveH5Code) {
        const pathInfo = await this.queryFormNamePath(this.basicForm.formApproveH5Code);
        this.$set(this.basicForm, 'formApproveH5NamePath', pathInfo.name);
        this.$set(this.basicForm, 'formApproveH5NamePathId', pathInfo.id);
      }
    },

    //  获取元数据表单列表
    async getFromList() {
      const params = { groupId: "", groupName: "", parentID: "", remark: "" };
      const res = await metadataService.dynFormGroupList(params);
      const array = res.data || [];
      await dealFrom(array);
      this.formList = array;
    },

    async queryFormNamePath(formCode) {
      return await metadataService.queryFormNamePath(formCode);
    },

    init() {
      let prjCategoryList = [];
      if (this.prjCategoryList) {
        prjCategoryList = this.prjCategoryList.map(item => {
          return {
            prjCategoryId: item
          };
        });
      }
      return prjCategoryList;
    },

    // 发起表单的change事件
    formCodeChange(type, layoutType) {
      if (!this.basicForm.formApprovePcCode) {
        const formId = this.basicForm[type];
        this.queryFormColumns(formId, layoutType);
      }
      this.updateBasic();
    },
    // 项目类型
    async getPrjType() {
      const res = await dicService.getDicList("folderTemplateType");
      this.dataPrjType = res.data || [];
    },
    // 审批表单的change事件
    approveCodeChange(type, layoutType) {
      const formId = this.basicForm[type] ? this.basicForm[type] : this.basicForm.formCode;
      this.queryFormColumns(formId, layoutType);
      this.updateBasic();
    },
    async queryFormColumns(formId, layoutType) {
      const res = await metadataService.queryFormColumns(formId);
      const array = res.data.filter((e) => e.isInternalField !== 1).map(e => {
        return {
          ...e,
          name: e.label,
          formField: e.name,
          isCanView: 1,
          isCanUpdate: 0,
          isRequired: e.required ? 1 : 0
        };
      }) || [];
      setFormFieldList(layoutType, array);
    },
    viewForm(type, layoutType) {
      this.layoutType = layoutType;
      const formId = this.basicForm[type];
      this.$refs.formViewDialog.openDialog(formId);
    },
    editForm(formIdPath) {
      if (!formIdPath) {
        return;
      }
      const routeUrl = this.$router.resolve({ name: "meta-data", query: { type: 'form', id: formIdPath }});
      window.open(routeUrl.href, "_blank");
    },
    canEditFlowCode() {
      if (this.viewMode === EditMode.CREATE_0) {
        return true;
      }
      return this.viewMode === EditMode.EDIT_1 && this.isFlowCodeNull;
    },
    // 打开选择人员
    async openCCPerson() {
      const props = {
        filterOneself: false,
        codePri: ["User", "SystemRole", "SpecRole", "PrjRole"],
        usersList: []
      };
      const val = await openMember(props);
      this.basicForm.ccList = val;
      this.updateBasic();
    },
    async additionalUpload() {
      const params = { prjId: "", folderId: "", versionId: "" };
      await uploader.getHiddenParams(params);
      const list = await uploader.open({ params, showPanel: true, once: true });
      list.forEach(this.fileAdded);
    },
    // 附件上传
    fileAdded(val) {
      changeFloderData(val);
    },
    deleteFiles(item) {
      deleteFloderData(item);
    },
    deleteCCUser(user) {
      this.basicForm.ccList = this.basicForm.ccList.filter(e => e.userId !== user.userId);
      this.updateBasic();
    },
    // 更新基础设置参数
    updateBasic() {
      if (this.basicForm.customerForm === 1) {
        this.basicForm.formCode = "";
        this.basicForm.formH5Code = ""; // 发起表单(h5)
        this.basicForm.formApprovePcCode = ""; // 审批表单(pc)
        this.basicForm.formApproveH5Code = ""; // 审批表单(h5)
        setFormFieldNull();
      }
      if (this.basicForm.formType === 0) {
        this.basicForm.enablePrjSelector = 0;
      }
      updateParams("basicForm", this.basicForm);
    },

    handleBuildTitle() {
      this.$refs.contentBuilderByFormFieldsDlg.show(this.basicForm.titleTemplate, 'title', this.fieldList);
    },

    handleBuildContent() {
      this.$refs.contentBuilderByFormFieldsDlg.show(this.basicForm.contentTemplate, 'content', this.fieldList, true);
    },

    finishEdit(obj) {
      if (obj.tag === 'title') {
        this.basicForm.titleTemplate = obj.content || "";
      } else {
        this.basicForm.contentTemplate = obj.content || "";
      }
      this.updateBasic();
    },

    // 校验表单
    validateFormData() {
      return new Promise((resolve) => {
        this.$refs.basicForm.validate(val => {
          resolve(val);
        });
      });
    },
    getImgUrl(num) {
      return require(`@/CommonDP/assets/xunhun/${num}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
#basicSetting {
  max-width: 900px;
  margin: auto;
}
.addPeople{
  width: 30px;
}

.radioList {
  display: flex;
  flex-direction: row;
  align-items: center;

  // justify-content: flex-start;
  // height: 40px;
  .el-radio {
    line-height: 40px;
  }

  .el-button {
    margin-left: 15px;
  }
}

.inlineStyle {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 0px;

  /deep/.el-form-item__label {
    float: left;
    min-width: 45px;
    width: auto !important;
  }

  /deep/.el-form-item__content {
    float: left;
    margin-left: 0 !important;
  }
}

.inlineList {
  width: 456px;
  /deep/ .dynForm {
    .el-input {
      width: 300px;
    }
  }
}

.tips {
  margin-left: 20px;
  color: #888;
  font-size: 0.8em;
}

.filesList {
  margin-top: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .file {
    padding: 5px 10px;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    border-radius: 5px;

    span {
      margin-right: auto;
    }

    i {
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .file:hover {
    background-color: #ebeef5;
  }
}
</style>
